const searchQueryParamName = "search";
export default searchQueryParamName;
